import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function CashMenu(){

const MenuCard = ({link,title,icon,color}) => (

<div className="col-xl-3 col-lg-4 col-md-6 mb-4">

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

</div>

);

return(

<section className="container-fluid mt-4">

<h5 className="menu-section-title">Cashier Requests / Approvals</h5>

<div className="row">

<MenuCard link="/cashier-op" title="OP Approvals" icon="fa-solid fa-user-check" color="#0d6efd"/>
<MenuCard link="/cashier-lab" title="Lab Approvals" icon="fa-solid fa-flask" color="#20c997"/>
<MenuCard link="/cashier-inv" title="Investigation Approvals" icon="fa-solid fa-x-ray" color="#6f42c1"/>
<MenuCard link="/cashier-min" title="Minor Treatment" icon="fa-solid fa-bandage" color="#fd7e14"/>
<MenuCard link="/cashier-ip" title="IP Approvals" icon="fa-solid fa-bed" color="#dc3545"/>
<MenuCard link="/cashier-pack" title="Package Approvals" icon="fa-solid fa-box" color="#0dcaf0"/>
<MenuCard link="/add-expense" title="Expense Approval" icon="fa-solid fa-receipt" color="#6610f2"/>
<MenuCard link="/refund-entry" title="Refund Approvals" icon="fa-solid fa-rotate-left" color="#ffc107"/>
<MenuCard link="/due-entry" title="Due Report Approval" icon="fa-solid fa-file-invoice-dollar" color="#198754"/>

</div>

<h5 className="menu-section-title">Cashier OP Reports</h5>

<div className="row">

<MenuCard link="/payment-detail" title="Payment Details" icon="fa-solid fa-money-check" color="#0d6efd"/>
<MenuCard link="/collection-all" title="Collection Detail" icon="fa-solid fa-coins" color="#20c997"/>
<MenuCard link="/collection-credit" title="Credit Pay Report" icon="fa-solid fa-credit-card" color="#6f42c1"/>
<MenuCard link="/due-report" title="Patient Due Report" icon="fa-solid fa-file-invoice" color="#dc3545"/>
<MenuCard link="/pending-bills" title="Pending Bills" icon="fa-solid fa-clock" color="#fd7e14"/>
<MenuCard link="/collection-op" title="OP Collection" icon="fa-solid fa-user-injured" color="#0dcaf0"/>
<MenuCard link="/collection-lab" title="Lab Collection" icon="fa-solid fa-flask" color="#6610f2"/>
<MenuCard link="/collection-inv" title="Investigation Collection" icon="fa-solid fa-x-ray" color="#ffc107"/>
<MenuCard link="/collection-min" title="Minor Treatment Collection" icon="fa-solid fa-bandage" color="#198754"/>
<MenuCard link="/refund-report" title="Refund Report" icon="fa-solid fa-rotate-left" color="#dc3545"/>
<MenuCard link="/cons-pay-report" title="Consultant Payment" icon="fa-solid fa-user-doctor" color="#0d6efd"/>
<MenuCard link="/discount-report" title="Discount Report" icon="fa-solid fa-percent" color="#fd7e14"/>
<MenuCard link="/expense-report" title="Expense Report" icon="fa-solid fa-receipt" color="#6f42c1"/>
<MenuCard link="/pat-bill-search" title="Patient Billing" icon="fa-solid fa-file-medical" color="#20c997"/>

</div>

<h5 className="menu-section-title">IP Reports</h5>

<div className="row">

<MenuCard link="/payment-detail-ip" title="IP Payment Detail" icon="fa-solid fa-money-check" color="#0d6efd"/>
<MenuCard link="/insur-report" title="Insurance Report" icon="fa-solid fa-shield-heart" color="#20c997"/>
<MenuCard link="/admit-list-date" title="Admission List" icon="fa-solid fa-bed-pulse" color="#6f42c1"/>
<MenuCard link="/discharge-list-date" title="Discharge List" icon="fa-solid fa-file-waveform" color="#fd7e14"/>

</div>

</section>

)

}

export default CashMenu;